"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooManyRequestsError = void 0;
const BaseError_1 = require("./BaseError");
/** TooManyRequestsError reports that a rate limit rejected the request. */
class TooManyRequestsError extends BaseError_1.BaseError {
    constructor(description = "Too Many Requests") {
        super("TooManyRequestsError", 429, description, true);
    }
}
exports.TooManyRequestsError = TooManyRequestsError;
